import { Typography } from 'antd'

import { RefundTableCell } from '../table.common'

const { Text } = Typography

export const CellUserNo: RefundTableCell<number> = (value) => (
	<Text
		underline
		copyable={{
			tooltips: ['복사하기', '✅ 복사완료!'],
		}}
	>
		{value}
	</Text>
)
